import styled from 'styled-components';
import { COLORS, FLEX_CONTAINER, FONT_FAMILY, FONTS } from 'utils/styles';
import { size, SIZE } from 'assets/styles/ScreenSize';

export const ButtonWrapper = styled.div`
  height: 100%;
  ${FLEX_CONTAINER.FlexSpaceBetweenColumn};
  margin-left: 0;

  @media only screen and (min-width: ${SIZE.tablet}) {
    align-items: flex-end;
  }
`;

export const InfoSectionContainer = styled.div`
  ${FLEX_CONTAINER.FlexColumn};
  align-items: unset;
  @media only screen and (max-width: 768px) {
    padding-left: 20px;
  }
`;

export const CardText = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  display: inline;

  @media (max-width: ${SIZE.mobile}) {
    margin-bottom: 12px;
    height: auto;
    width: 200px;
  }

  @media (min-width: ${SIZE.tablet}) {
    margin-bottom: 10px;
  }

  @media (min-width: ${SIZE.bigDesktop}) {
    margin-bottom: 12px;
  }
`;

export const PriceText = styled.p`
  color: ${COLORS.mainColor};
  ${FONT_FAMILY.FontBold};
  font-size: 14px;
  display: inline;
`;

export const CardTitle = styled.p`
  ${FONT_FAMILY.FontMedium}
  color: ${COLORS.mainColor};

  @media (min-width: ${SIZE.mobile}) {
    ${FONTS.font16}
    margin-bottom: 12px;
  }

  @media (min-width: ${SIZE.tablet}) {
    ${FONTS.font16}
    margin-bottom: 10px;
  }

  @media (min-width: ${SIZE.bigDesktop}) {
    ${FONTS.font20}
    margin-bottom: 18px;
  }
`;

export const OfferCards = styled.div`
  ${FLEX_CONTAINER.FlexColumn};
  width: 100%;
  height: 565px;
  overflow-y: auto;
  padding: 10px 50px;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${COLORS.darkGray};
    background: ${COLORS.lightGray};
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.mainColor};
    border-radius: 10px;
  }
`;

export const OfferMainWrapper = styled.div`
  ${FLEX_CONTAINER.FlexColumn};
  width: 100%;
  height: 565px;
  overflow-y: auto;
  padding: 10px 40px;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${COLORS.darkGray};
    background: ${COLORS.lightGray};
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.mainColor};
    border-radius: 10px;
  }
`;

export const MessageCardsWrapper = styled.div`
  background: ${COLORS.white};
  ${FLEX_CONTAINER.FlexRow};
  width: 100%;
  height: 204px;
  border-radius: 16px;

  @media (min-width: ${SIZE.mobile}) {
    ${FLEX_CONTAINER.FlexColumn};
    height: auto;
    margin-bottom: 26px;
    width: 224px;
  }

  @media (min-width: ${SIZE.iphone}) {
    ${FLEX_CONTAINER.FlexColumn};
    height: auto;
    width: 282px;
  }

  @media (min-width: ${SIZE.tablet}) {
    ${FLEX_CONTAINER.FlexRow};
    width: 100%;
    height: auto;
  }

  @media (min-width: ${SIZE.desktop}) {
    margin-bottom: 20px;
  }

  @media (min-width: ${SIZE.bigDesktop}) {
    height: 204px;
    margin-bottom: 30px;
  }
`;

export const ImageAndLike = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  justify-content: center;
  position: relative;
  width: 400px;
  height: 204px;
`;

export const LikeIcon = styled.div`
  border-radius: 0;
  position: absolute;
  z-index: 2;
  top: 6px;
  right: 6px;

  @media (max-width: ${size.laptopL}) {
    right: 20px;
  }

  @media (max-width: ${SIZE.tablet}) {
    right: 62px;
  }
`;

export const LikeImg = styled.img`
  width: 40px;
  height: 40px;
`;

export const InfoSection = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}
  width: 100%;
  padding: 14px 16px 18px 10px;

  @media only screen and (max-width: ${size.desktop}) {
    padding: 14px 16px 18px 10px;
  }

  @media only screen and (${size.laptopL}) {
    padding: 14px 18px 0 38px;
  }

  @media only screen and (max-width: ${size.tablet}) {
    padding: ${({ AreOffers }) => (AreOffers ? '12px 0 14px 0px' : '12px 0 14px 0')};
    flex-direction: column;
    align-items: ${({ AreOffers }) => (AreOffers ? 'unset' : 'center')};
  }

  @media only screen and (max-width: ${size.mobileM}) {
    padding: 10px 0 14px;
  }
`;

export const StyledImage = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ backgroundImage }) =>
    backgroundImage ? `url(${backgroundImage})` : null};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  @media (max-width: ${SIZE.tablet}) {
    width: ${({ AreOffers }) => (AreOffers ? '100%' : '180px')};
  }
`;

export const StyledSeeMoreButton = styled.button`
  margin-top: 120px;
  background: ${COLORS.mainColor};
  ${FONTS.font16};
  border-radius: 10px;
  color: ${COLORS.white};
  border: none;
  width: 180px;
  height: 40px;

  @media (max-width: ${SIZE.mobile}) {
    width: 160px;
    height: 30px;
    ${FONTS.font14}
  }

  @media (max-width: ${SIZE.tablet}) {
    width: 150px;
    height: 30px;
    ${FONTS.font14};
    margin-top: 10px;
  }

  @media (max-width: ${SIZE.desktop}) {
    width: 120px;
    height: 34px;
    ${FONTS.font16}
  }

  @media (max-width: ${SIZE.bigDesktop}) {
    width: 174px;
    height: 40px;
    ${FONTS.font16}
  }
`;

export const OnePersonPrice = styled.span`
  color: ${COLORS.mainColor};
  margin-left: 4px;
  display: inline;

  @media (max-width: ${SIZE.mobile}) {
    ${FONTS.font14};
    word-break: break-all;
    margin-left: 10px;
  }

  @media (max-width: ${SIZE.tablet}) {
    ${FONTS.font14};
  }

  @media (max-width: ${SIZE.desktop}) {
    ${FONTS.font16}
  }

  @media (max-width: ${SIZE.bigDesktop}) {
    ${FONTS.font16}
  }
`;

export const UserOfferCards = styled.div`
  ${FLEX_CONTAINER.FlexColumn};
  width: 100%;
  overflow-y: auto;
  padding-left: 10px;
  padding-right: 50px;

  @media only screen and (max-width: ${size.laptopL}) {
    padding-right: 40px;
  }

  @media only screen and (max-width: ${size.tablet}) {
    padding-right: 10px;
  }

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${COLORS.darkGray};
    background: ${COLORS.lightGray};
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.mainColor};
    border-radius: 10px;
  }
`;

export const OfferStyledWrapper = styled.div`
  width: 100%;
  height: 565px;
`;

export const OffersSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 500px;
  overflow-y: auto;
  padding: 10px 40px;

  @media only screen and (max-width: ${size.laptopL}) {
    align-items: center;
    overflow-x: hidden;
  }

  @media only screen and (max-width: ${size.tablet}) {
    height: 565px;
  }

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${COLORS.darkGray};
    background: ${COLORS.lightGray};
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.mainColor};
    border-radius: 10px;
  }
`;

export const AboutOfferDescription = styled.div`
  background: ${COLORS.white};
  ${FLEX_CONTAINER.FlexRow};
  width: 100%;
  height: 204px;
  border-radius: 16px;
  flex-shrink: 0;

  @media only screen and (max-width: ${size.tablet}) {
    ${FLEX_CONTAINER.FlexColumn};
    margin-bottom: 20px;
    height: 374px;
    width: 278px;
  }

  @media only screen and (max-width: ${size.mobileL}) {
    width: 224px;
  }
`;

export const ImageContainer = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  justify-content: center;
  position: relative;
  width: 400px;
  height: 204px;

  @media only screen and (max-width: ${size.laptopL}) {
    width: 200px;
    flex-shrink: 0;
  }

  @media only screen and (max-width: ${size.tablet}) {
    width: 100%;
    height: 147px;
  }
`;

export const OfferImage = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ backgroundImage }) =>
    backgroundImage ? `url(${backgroundImage})` : null};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 14px 0 0 14px;

  @media only screen and (max-width: ${size.tablet}) {
    border-radius: 14px 14px 0 0;
  }

  @media only screen and (max-width: ${size.mobileL}) {
    border-radius: 14px 14px 0 0;
  }
`;

export const DescriptionContainer = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}
  width: 100%;
  padding: 14px 16px 18px 10px;

  @media only screen and (max-width: ${size.desktop}) {
    padding: 14px 16px 18px 10px;
  }

  @media only screen and (${size.laptopL}) {
    padding: 14px 18px 0 38px;
  }

  @media only screen and (max-width: ${size.tablet}) {
    padding: ${({ areOffers }) => (areOffers ? '12px 0 14px 0px' : '12px 0 14px 0')};
    flex-direction: column;
    align-items: ${({ areOffers }) => (areOffers ? 'unset' : 'center')};
  }

  @media only screen and (max-width: ${size.mobileM}) {
    padding: 10px 0 14px;
  }
`;

export const DescriptionMainBlock = styled.div`
  ${FLEX_CONTAINER.FlexColumn};
  justify-content: space-between;
  align-items: unset;
  height: 174px;

  @media only screen and (max-width: ${size.tablet}) {
    height: 106px;
    padding-left: 20px;
  }
`;

export const OfferTitle = styled.p`
  ${FONTS.font20};
  ${FONT_FAMILY.FontMedium}
  color: ${COLORS.mainColor};

  @media only screen and (max-width: ${size.laptopL}) {
    ${FONTS.font18};
  }

  @media only screen and (max-width: ${size.tablet}) {
    ${FONTS.font16};
  }

  @media only screen and (max-width: ${size.mobileL}) {
    ${FONTS.font14};
  }
`;

export const InfoWrapper = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  display: inline;
`;

export const TitleParagraph = styled.p`
  color: ${COLORS.mainColor};
  ${FONT_FAMILY.FontBold};
  ${FONTS.font16};
  display: inline;

  @media only screen and (max-width: ${size.tablet}) {
    ${FONTS.font14};
  }

  @media only screen and (max-width: ${size.mobileL}) {
    ${FONTS.font12};
  }
`;

export const ParagraphInfo = styled.span`
  color: ${COLORS.mainColor};
  margin-left: 4px;
  ${FONTS.font16};
  display: inline;

  @media only screen and (max-width: ${size.tablet}) {
    ${FONTS.font14};
  }

  @media only screen and (max-width: ${size.mobileL}) {
    ${FONTS.font12};
  }
`;

export const SeeMoreButtonContainer = styled.div`
  display: flex;
  align-items: end;
  height: 174px;

  @media only screen and (max-width: ${size.tablet}) {
    height: auto;
    width: 100%;
    margin-top: 30px;
    align-items: center;
    justify-content: center;
  }
`;

export const SeeMoreButton = styled.button`
  background: ${COLORS.mainColor};
  ${FONTS.font16};
  border-radius: 10px;
  color: ${COLORS.white};
  border: none;
  width: 180px;
  height: 40px;
`;
